import rawIsotopes from "../assets/Isotopes.db.json";
import Nuclide from "../models/Nuclide";
import DecayChain from "../models/DecayChain";

const nuclides = {
  total: 0,
  pLength: 0,
  pMax: Number.MIN_SAFE_INTEGER,
  pMin: Number.MAX_SAFE_INTEGER,
  highest: {
    neutron: 0,
    proton: 0,
  },
  flatten: [],
};
//example get nuclides[proton][neutron]

const processRawIsotopes = (raw) => {
  let nuclide;
  nuclides.total = raw.length;
  for (const isotope of raw) {
    nuclide = new Nuclide(isotope);
    if (nuclide.proton in nuclides) {
      const nNuclides = nuclides[nuclide.proton];

      nNuclides.nLength++;
      nNuclides[nuclide.neutron] = nuclide;
      nNuclides.nMax = Math.max(nNuclides.nMax, nuclide.neutron);
      nNuclides.nMin = Math.min(nNuclides.nMin, nuclide.neutron);
    } else {
      nuclides[nuclide.proton] = {
        nLength: 1,
        nMax: nuclide.neutron,
        nMin: nuclide.neutron,
        [nuclide.neutron]: nuclide,
      };

      nuclides.pLength++;
      nuclides.pMax = Math.max(nuclides.pMax, nuclide.proton);
      nuclides.pMin = Math.min(nuclides.pMin, nuclide.proton);
    }

    nuclides.highest.neutron = Math.max(
      nuclides.highest.neutron,
      nuclide.neutron
    );
    nuclides.highest.proton = Math.max(nuclides.highest.proton, nuclide.proton);
  }
  for (let p = nuclides.pMin; p <= nuclides.pMax; p++) {
    const pn = nuclides[p];
    if (pn) {
      for (let n = pn.nMin; n <= pn.nMax; n++) {
        const nn = pn[n];
        if (nn) {
          nn.index = nuclides.flatten.length;
          nuclides.flatten.push(nn);
        }
      }
    }
  }
};
processRawIsotopes(rawIsotopes);

export default nuclides;

export const getDecayChain = (nuclide) => {
  /**use to prevent circular path */
  const path = new Set();
  const chain = calcDecayChain(nuclide, false, path);

  return chain;
};

const calcDecayChain = (nuclide, isSecondary, path) => {
  const decayChain = new DecayChain(nuclide, isSecondary);

  const primDecayMode = nuclide.primary_decay?.toLowerCase().trim();
  const secDecayMode = nuclide.secondary_decay?.toLowerCase().trim();

  if (primDecayMode !== "spontaneous fission") {
    addDaughterBasedOnMode(primDecayMode, decayChain, false, path);
  }
  if (secDecayMode !== "spontaneous fission") {
    addDaughterBasedOnMode(secDecayMode, decayChain, true, path);
  }
  return decayChain;
};

const addDaughterBasedOnMode = (decayMode, currChain, isSecondary, path) => {
  let diffNeutron = 0;
  let diffProton = 0;
  switch (decayMode) {
    case "alpha":
      diffNeutron = -2;
      diffProton = -2;
      break;
    case "beta minus":
      diffNeutron = -1;
      diffProton = +1;
      break;
    case "double beta":
      diffNeutron = -2;
      diffProton = +2;
      break;
    case "electron capture/positron":
    case "electron capture x-ray":
    case "positron":
      diffNeutron = +1;
      diffProton = -1;
      break;
    case "double electron capture x-ray":
      diffNeutron = +2;
      diffProton = -2;
      break;
    case "neutron":
      diffNeutron = -1;
      diffProton = 0;
      break;
    case "proton":
      diffNeutron = 0;
      diffProton = -1;
      break;
    case "spontaneous fission":
    case "unknown":
    case "stable":
    default:
    // setDaughter(currChain, -2, -2); //testing only
  }

  if (diffNeutron && diffProton) {
    const n = currChain.nuclide.neutron + diffNeutron;
    const p = currChain.nuclide.proton + diffProton;
    const nextNuclide = nuclides[p]?.[n];
    if (nextNuclide) {
      const currPath = `${currChain.nuclide.symbol} -> ${nextNuclide.symbol}`;
      if (path.has(currPath)) {
        currChain.isCircular = true;
      } else {
        path.add(currPath);
        currChain.addDaughter(calcDecayChain(nextNuclide, isSecondary, path));
      }
    }
  }
};

export const isNuclideExist = (nuclide) =>
  Boolean(nuclide && getNuclide(nuclide));

export const getNuclide = (t) => t && nuclides[t.proton]?.[t.neutron];

export const isNuclideIdentical = (a1, a2) =>
  a1?.proton === a2?.proton && a1?.neutron === a2?.neutron;
